"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RIGHT = exports.BOTTOM = exports.LEFT = exports.TOP = exports.SOLID = exports.OUTLINE = exports.DARK = exports.LIGHT = void 0;
exports.LIGHT = 'light';
exports.DARK = 'dark';
exports.OUTLINE = 'outline';
exports.SOLID = 'solid';
exports.TOP = 'top';
exports.LEFT = 'left';
exports.BOTTOM = 'bottom';
exports.RIGHT = 'right';
//# sourceMappingURL=types.js.map